import { useEffect, useReducer, useState } from "react";
import { Box } from "@mui/material";
import reduceStormOptionsOne, {
 defaultReducedStormOptionsOne,
} from "../../../store/stormOptionsOne";
import reduceStormOptionsTwo, {
 defaultReducedStormOptionsTwo,
} from "../../../store/stormOptionsTwo";
import Sidebar from "../Sidebar/Sidebar";
import MapComponent from "../Maps/Map1/MapComponent";
import BrowserAppBar from "../Navigation/BrowserAppBar";
import SecondMapComponent from "../Maps/Map2/SecondMapComponent";
import "./Pages.css";

const BrowserMainPage = () => {
 const [open, setOpen] = useState(true);
 const [mapExtent, setMapExtent] = useState();
 const [mapExtent2, setMapExtent2] = useState();
 const [checked, setChecked] = useState(false);
 const [drawerWidth, setDrawerWidth] = useState(325);
 const [withAdaptations, setWithAdaptations] = useState(false);
 const [appContentClassname, setAppContentClassname] =
  useState("app-content-open");
 const [sidebarPullerClassname, setSidebarPullerClassname] = useState(
  "sidebar-puller-open"
 );
 const [reductionStateOne, setReductionStateOne] = useReducer(
  reduceStormOptionsOne,
  defaultReducedStormOptionsOne
 );
 const [reductionStateTwo, setReductionStateTwo] = useReducer(
  reduceStormOptionsTwo,
  defaultReducedStormOptionsTwo
 );
 const [criticalAssetsEnabled, setCriticalAssetsEnabled] = useState(false);
 const [criticalAssetsEnabled2, setCriticalAssetsEnabled2] = useState(false);
 const [searchResultsFeature, setSearchResultsFeature] = useState();

 useEffect(() => {
  setMapExtent(mapExtent2);
 }, [mapExtent2]);

 useEffect(() => {
  setMapExtent2(mapExtent);
 }, [mapExtent]);

 useEffect(() => {
  if (!!checked) {
   setDrawerWidth(653);
   setAppContentClassname("app-content-open-compare");
   setSidebarPullerClassname("sidebar-puller-open-compare");
  } else {
   setDrawerWidth(325);
   setAppContentClassname("app-content-open");
   setSidebarPullerClassname("sidebar-puller-open");
  }
 }, [checked]);

 const btnClickOne = async (type, value) => {
  setReductionStateOne({ type: type, value: value });
 };

 const btnClickTwo = async (type, value) => {
  setReductionStateTwo({ type: type, value: value });
 };

 return (
  <Box className="main-page-box">
   <BrowserAppBar
    open={open}
    checked={checked}
    setChecked={setChecked}
    drawerWidth={drawerWidth}
    withAdaptations={withAdaptations}
    setWithAdaptations={setWithAdaptations}
   />
   <Sidebar
    open={open}
    setOpen={setOpen}
    checked={checked}
    setChecked={setChecked}
    btnClickOne={btnClickOne}
    btnClickTwo={btnClickTwo}
    drawerWidth={drawerWidth}
    reductionStateOne={reductionStateOne}
    reductionStateTwo={reductionStateTwo}
    withAdaptations={withAdaptations}
    setWithAdaptations={setWithAdaptations}
    sidebarPullerClassname={sidebarPullerClassname}
   />

   <div
    className={!!open && !!checked ? "compare-map-row-open" : "compare-map-row"}
   >
    <MapComponent
     open={open}
     checked={checked}
     mapExtent={mapExtent}
     setMapExtent={setMapExtent}
     drawerWidth={drawerWidth}
     reductionState={reductionStateOne}
     appContentOpenClassname={appContentClassname}
     criticalAssetsEnabled={criticalAssetsEnabled}
     setCriticalAssetsEnabled={setCriticalAssetsEnabled}
     setSearchResultsFeature={setSearchResultsFeature}
    />
    {!!checked && (
     <SecondMapComponent
      open={open}
      checked={checked}
      drawerWidth={drawerWidth}
      mapExtent={mapExtent2}
      setMapExtent={setMapExtent2}
      reductionState={reductionStateTwo}
      searchResultsFeature={searchResultsFeature}
      appContentOpenClassname={appContentClassname}
      criticalAssetsEnabled={criticalAssetsEnabled2}
      setCriticalAssetsEnabled={setCriticalAssetsEnabled2}
     />
    )}
   </div>
  </Box>
 );
};

export default BrowserMainPage;
